export default __webpack_public_path__ + "static/media/sample1.199ceb60.jpeg";